import { render, staticRenderFns } from "./Annexes.vue?vue&type=template&id=28d090d8"
import script from "./Annexes.vue?vue&type=script&lang=ts"
export * from "./Annexes.vue?vue&type=script&lang=ts"
import style0 from "./Annexes.vue?vue&type=style&index=0&id=28d090d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports